export const STATE_CODES_BY_NAME: Record<string, string> = {
  alabama: 'AL',
  alaska: 'AK',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  florida: 'FL',
  georgia: 'GA',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  'west virginia': 'WV',
  wisconsin: 'WI',
  wyoming: 'WY',
};

export const US_STATE_OPTIONS = Object.values(STATE_CODES_BY_NAME).sort();

const stateCodeSet = new Set(US_STATE_OPTIONS);

export const getStateSearchCode = (query: string) => {
  const normalized = query.trim().replaceAll('.', '').toLowerCase();
  if (STATE_CODES_BY_NAME[normalized]) return STATE_CODES_BY_NAME[normalized];

  const upper = normalized.toUpperCase();
  return stateCodeSet.has(upper) ? upper : '';
};

export const getStateFromAddress = (value: string) => {
  const normalized = value.trim().toUpperCase();
  const pattern = /\b([A-Z]{2})\b(?=(?:\s+\d{5}(?:-\d{4})?)?[ ,]*$)/g;
  let state = '';
  let match = pattern.exec(normalized);

  while (match) {
    state = match[1];
    match = pattern.exec(normalized);
  }

  return stateCodeSet.has(state) ? state : '';
};

export const normalizeStateCriterion = (value: string) => {
  const stateCode = getStateSearchCode(value);
  if (stateCode) return stateCode;

  return value.trim().toLowerCase().replaceAll(/\s+/g, ' ');
};
